import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { AddBillingTemplateModalForm } from './form';
// import useStyles from './styles';
// import { useStore } from 'src/stores';

export const AddEditBillingTemplateModal = observer(_ref => {
  let companyCredentials = _ref.companyCredentials,
    propertyId = _ref.propertyId,
    currentBuildingId = _ref.currentBuildingId,
    existingPropertyProviders = _ref.existingPropertyProviders,
    customTrigger = _ref.customTrigger,
    isEditBillingTemplate = _ref.isEditBillingTemplate,
    isCredentialsUpdate = _ref.isCredentialsUpdate,
    propertyUtility = _ref.propertyUtility,
    callbackTrigger = _ref.callbackTrigger;
  // const classes = useStyles();
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const internalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '194-add-edit-billing-template-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.add_billing_template')));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    title: t("add_new_property_flow.".concat(isEditBillingTemplate ? 'edit_billing_template' : 'add_billing_template')),
    trigger: customTrigger !== undefined ? customTrigger : internalTrigger
  }, /*#__PURE__*/React.createElement(AddBillingTemplateModalForm, {
    companyCredentials: companyCredentials,
    propertyId: propertyId,
    existingPropertyProviders: existingPropertyProviders,
    isEditBillingTemplate: isEditBillingTemplate,
    isCredentialsUpdate: isCredentialsUpdate,
    propertyUtility: propertyUtility,
    callbackTrigger: callbackTrigger,
    currentBuildingId: currentBuildingId
  }));
});